const setAnalytics = (digitalData) => {
  const _ddo = digitalData.init();

  window._T = window._T || {};

  if (typeof window._T.pageData === 'undefined') {
    window._T.pageData = [];
  }
  window._T.pageData.push(_ddo);
};

const pushEventInfo = (analyticsEvent) => {
  if (analyticsEvent && window.digitalData) {
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(analyticsEvent);
    setAnalytics(window.digitalData);
  }
};

export const handleTileAnalytics = (prefix, message) => {
  pushEventInfo({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'my account settings' },
    myAccount: { settings: `${prefix} ${message}` },
  });
};

export const handleFooterAnalytics = (prefix, message) => {
  pushEventInfo({
    category: { primaryCategory: 'stash' },
    eventInfo: { eventName: 'my account settings' },
    eventMode: 'stash',
    stash: { myAccount: { settings: `${prefix} ${message}` } },
  });
};
